import { dispatchPromise } from './action-helpers';

export const showModal = (modalType, modalProps) => {
    return dispatchPromise({
        type: 'SHOW_MODAL',
        payload: {
            modalType,
            modalProps
        }
    });
}

export const hideModal = () => {
    return dispatchPromise({
        type: 'HIDE_MODAL',
        payload: null
    });
}
